import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { getSnapshotConfiguration } from 'src/app/common/models/configurations.model';
import { SnapshotService } from '../Services/snapshot.service'; // Replace './path/to/addSnapshotConfiguration' with the actual path to the addSnapshotConfiguration file
import { LoaderService } from '../../../common/services/loader.service';
import { CommonChartmoduleService } from '../Services/common-chartmodule.service';
import { Router } from '@angular/router';
import { AfterViewInit } from '@angular/core';
import { set } from 'lodash';
import { Subscription } from 'rxjs';
import { CheckboxSelectionModel } from 'src/app/common/constants/common-constants';
import { AlertMessageModel } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';

@Component({
  selector: 'app-moduleconfiguration',
  templateUrl: './module-configuration.component.html',
  styleUrls: ['./module-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModuleconfigurationComponent implements OnChanges {

  @Input() id: number | undefined;
  @Input() currentSnapshotList: any;
  @Input() selectedSnapshotData: any | undefined;
  @Output() isSubmitted = new EventEmitter<boolean>();
  @Output() alreadyExisting = new EventEmitter<boolean>();

  @ViewChild('snapshotInput') snapshotInput:
    | ElementRef<HTMLInputElement>
    | undefined;

  form: FormGroup;
  defaultselectedWidget = '6 Widget Layout';
  selectedwidget: string = this.defaultselectedWidget;
  popUpTitle: string = "Error";
  private subscriptions: Subscription = new Subscription();
  isSubmit: boolean = true;

  //Flags
  defaultAnswerBaseInput: boolean = true;
  answerBaseInput: boolean = this.defaultAnswerBaseInput;
  popUpMessage: any = '';
  errorheaderTitle: any = '';
  defaultStaticTextAreaFlag: Boolean = true;
  showStaticTextAreaFlag: Boolean = this.defaultStaticTextAreaFlag;
  defaultOutputConfig: string = 'user';
  outputConfig: string = this.defaultOutputConfig;
  defaultStickyorDefault: string = 'sticky';
  stickyDefaultSelected: string = this.defaultStickyorDefault;
  defaultResetSelectionFlag = true;
  resetSelectionFlag: Boolean = this.defaultResetSelectionFlag;
  showStudyNameDropdown: Boolean = false;
  statictext: string = '';
  data = this._configService.clientData;
  snapshotData: any = {};
  dataExistance: Boolean = this._configService.ifDataExists;
  snapCountNum: number = this.snapshotCount.snapshotCount;
  snapshotName: string = '';
  snapshotType: string = '';
  docFolderType: string = '';
  docFileType: string = '';
  studyName: string = '';
  numberOfWidget: number = 4;
  snapshotLayout: string = '';
  togglestudyName: Boolean = false;
  showSingleBrand: boolean = false;
  showMultiBrand: boolean = false;
  showMultiCategory: boolean = false;
  showMultiMarket: boolean = false;
  showSubmitPopUp: boolean = false;
  showPopUp = false;
  showErrorPopUp = false;
  showDeletePopup = false;
  lastSelectedOption: any = null;
  lastSelectedType: string = '';

  checkedList: any = [];
  snapshotNamesList: any = [];
  moduleConfigPropertiesDisplay = [];
  saveSelectionCheckedList: any = [];
  userManagementCheckedList: any = [];
  additionalCheckBoxCheckedList: any = [];
  customContentCheckedList: any = [];
  comparisionCheckedList: any = [];
  exportEntryPoints: any = [];
  exportDimensions: any = [];
  significanceTypeCheckedList: any = [];
  exportCheckedList: any = [];
  multipleConfidenceCheckedList: any = [];


  constructor(
    private fb: FormBuilder,
    private snapshotCount: SnapshotSharedVariablesService,
    public _configService: SnapshotService,
    private clientDetails: SnapshotSharedVariablesService,
    private snapshotDetails: SnapshotSharedVariablesService,
    private _loaderService: LoaderService,
    private commonchartservice: CommonChartmoduleService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private _alertService: AlertMessageService
  ) {
    this.form = new FormGroup({
      snapshotName: new FormControl(''),
      snapshotType: new FormControl(''),
      docFolderType: new FormControl(''),
      docFileType: new FormControl(''),
      newFileText: new FormControl(''),
      studyName: new FormControl(''),
      staticText: new FormControl(''),
      widgetTypeForm: new FormControl(''),
    });

  }

  async ngOnInit() {

    this.additionalCheckBoxSelection.forEach((item: any) => {
          item.selected = false;
    })

    this._loaderService.showLoader();

    const res = await this._configService
      .getConfigurationByClientName(this.clientDetails.clientDetails.client_name)
      .toPromise()
      .then((c) => {
        this.data = JSON.parse(c.Data);
        this._configService.clientData = this.data;


        this.studyNames = [];
        this.snapshotDetails.studyNameDetails = [];


        for (let i = 0; i < this.data.length; i++) {

          if (
            this.data[i].configData.study != undefined &&
            this.data[i].configData.study != null &&
            this.data[i].configData.study != ''
          ) {
            this.snapshotDetails.studyNameDetails.push(
              this.data[i].configData.study
            );

          }
        }

        this.studyNames = this.snapshotDetails.studyNameDetails.map(
          (studyName: string, index: number) => {
            return { id: index, name: studyName, selected: false };
          }
        );
      }
      );

    this.form = this.fb.group({
      snapshotName: [''],
      snapshotType: [''],
      docFolderType: [''],
      docFileType: [''],
      newFileText: [''],
      studyName: [''],
      staticText: [''],
      widgetTypeForm: [''],
    });

    // this._configService.productSelected = this.snapshotData.product;
    // this._configService.templateSelected = this.snapshotData.product_type;


    this.subscriptions.add(
      await this._configService.getModuleConfigProperties().subscribe(async (data) => {
        this._configService.moduleConfigPropertiesEnableDisable = JSON.parse(data.Data);
        if (this.clientDetails.clientDetails.study != "") {
          await setTimeout(async () => {
            await this.getStudyDetails();
          }, 100);
        }
        await this.CheckModuleConfigProperties();
      }));


    const inputElement = document.querySelector(
      '.snapshotName'
    ) as HTMLInputElement;

    if (this.selectedSnapshotData == undefined) {
      this.selectedSnapshotData = {
        clientName: this.clientDetails.clientDetails.client_name,
        snapshotName: this.clientDetails.clientDetails.study
      }
    }

    // this.GetClientExistingSnapshotData("Test folder creation","payel12-new","Single Brand");
    if (this.selectedSnapshotData.snapshotName != '') {
      await setTimeout(async () => {
        await this.GetClientExistingSnapshotData(
          this.selectedSnapshotData.clientName,
          this.selectedSnapshotData.snapshotName
        );
      }, 100);
      if (inputElement != null) {
        inputElement.disabled = true;
        inputElement.classList.add('disabled');
      }
      else if (this._configService.afterRefreshShowModuleConfig) {
        console.log("afterRefreshShowModuleConfig: " +
          this._configService.afterRefreshShowModuleConfig);
        // find the div with classname general_configuaration and click
        const snapshotConfigurationTabs = document.querySelector('.general_configuaration');
        if (snapshotConfigurationTabs) {
          this._configService.afterRefreshShowModuleConfig = false;
          //make display block for div with classname dropdown-container
          const dropdownContainer = document.querySelector('.dropdown-container');
          if (dropdownContainer) {
            (dropdownContainer as HTMLElement).style.display = 'flex';
          }

          (snapshotConfigurationTabs as HTMLElement).click();

        }
      }
    }



    // this.studyNames.forEach((study: any) => {
    //   study.selected = false;
    // });

    // const snapLayoutInput = document.querySelector(
    //   '.SnapshotFieldInputLayout'
    // ) as HTMLElement;
    // snapLayoutInput.innerHTML = this.selectedwidget;

    if (this.selectedSnapshotData.snapshotName == '') {
      this.clearAll();
      inputElement.classList.remove('disabled');
    }
    const clientNameArea = document.querySelector('.client-name-area');
    if (clientNameArea) {
      clientNameArea.textContent = this.clientDetails.clientDetails.client_name;
    }

  }

  ngOnChanges(changes: SimpleChanges) {

    //if (changes.id) {
    // The id has changed. Re-initialize the form here.
    this.form.reset();
    //}

    // this.snapshotName = '';
    // this.snapshotType = '';
    // this.studyName = '';
    this.numberOfWidget = 4;
    // this.snapshotLayout = '';
  }

  snapshotTypes = [
    { name: 'Brand Snap' },
    { name: 'Category Snap' },
    { name: 'Dummy Snap' },
  ];
  //delete
  docRepFolderTypes = [
    { name: 'Folder 1' },
    { name: 'Folder 2' },
  ];
  docRepFileTypes = [
    { name: 'File 1' },
    { name: 'File 2' },
  ];
  //delete end
  studyNames = [
    { id: 0, name: 'Study 1', selected: false },
    { id: 1, name: 'Study 2', selected: false },
    { id: 2, name: 'Dummy Study', selected: false },
  ];
  numberOfWidgets = [
    { name: 4 },
    { name: 5 },
    { name: 6 },
    { name: 7 },
    { name: 8 },
    { name: 9 },
    { name: 10 },
    { name: 11 },
    { name: 12 },
    { name: 13 },
    { name: 14 },
    { name: 15 },
    { name: 16 },
    { name: 17 },
    { name: 18 },
    { name: 19 },
    { name: 20 },
    { name: 21 },
    { name: 22 },
    { name: 23 },
    { name: 24 },
  ];

  entryPointsSB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsSB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  entryPointsMB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsMB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];
  entryPointsMC = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsMC = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];
  entryPointsMM = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsMM = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  comparisonPoints = [
    { id: 1, selected: false, name: 'Previous Year', value: 'previousYear' },
    {
      id: 2,
      selected: false,
      name: 'Previous Period',
      value: 'previousPeriod',
    },
    { id: 3, selected: false, name: 'Pairwise', value: 'pairWise' },
    { id: 3, selected: false, name: 'Reference', value: 'reference' },
  ];

  saveSelection = [
    { id: 1, selected: false, name: 'Save/Load', value: 'Save/Load' },
    { id: 2, selected: false, name: 'Change of Entry Points in Saved Selection', value: 'ChangeEntryPoints' },
  ];

  outputconfiguration = [
    { id: 1, selected: true, name: 'Admin Defined', value: 'admin' },
  ];

  stickyDefaultSelection = [
    { id: 1, selected: true, name: 'Sticky', value: 'sticky' },
    { id: 2, selected: false, name: 'Default', value: 'default' },
  ];

  userManagementSelection = [
    { id: 1, selected: false, name: 'Entry Point', value: 'entryPoint' },
    { id: 2, selected: false, name: 'Dimension', value: 'dimension' },
  ];

  significance = [
    { id: 1, selected: false, name: 'Z Test', value: 'zTest' },
    { id: 2, selected: false, name: 'Test 2', value: 'test2' },
    { id: 3, selected: false, name: 'Test 3', value: 'test3' },
  ];

  multipleConfidence = [
    { id: 1, selected: false, name: '90%', value: '90%' },
    { id: 2, selected: false, name: '95%', value: '95%' },
    { id: 3, selected: false, name: '99%', value: '99%' },
  ];

  customContentSelection = [
    { id: 1, selected: false, name: 'Custom Groups', value: 'customGroups' },
    { id: 2, selected: false, name: 'Custom Calculations', value: 'customCalculations' },
    { id: 3, selected: false, name: 'Custom Reports', value: 'customReports' },
  ];

  export = [
    { id: 1, selected: false, name: 'Editable PPT', value: 'exportPPT' },
    {
      id: 2,
      selected: false,
      name: 'Non-Editable PPT',
      value: 'nonEditablePPT',
    },
    { id: 3, selected: false, name: 'Excel Export', value: 'excelExport' },
  ];

  additionalCheckBoxSelection = CheckboxSelectionModel.additionalCheckBoxSelection;

  reset = [
    { id: 1, selected: this.resetSelectionFlag, name: 'Yes', value: 'yes' },
    { id: 2, selected: !this.resetSelectionFlag, name: 'No', value: 'no' },
  ];

  toggleAnswerBase() {
    this.answerBaseInput = !this.answerBaseInput;
  }

  onStaticTextChanged(event: any) {
    // Capture the value of the textarea and store it in the staticText variable
    this.statictext = event.target.value;
  }

  numberOfWidgetsCLick(event: any) {
    this.numberOfWidget = Number(event.target.value);
  }


  CheckModuleConfigProperties() {
    let dataAll = this._configService.moduleConfigPropertiesEnableDisable;

    let productName = this._configService.productSelected;
    let templateName = this._configService.templateSelected;
    if (productName == "Standard")
      this.moduleConfigPropertiesDisplay = dataAll.filter((item: any) => {
        if (item.Product === productName && item.Template === templateName && item.Template !== "NA")
          return item;
      });
    else
      this.moduleConfigPropertiesDisplay = dataAll.filter((item: any) => {
        if (item.Product === productName)
          return item;
      });
    this.cdr.detectChanges();



    if (this.moduleConfigPropertiesDisplay.length != 0)
      this.CheckEnableDisableForFields();
  }

  CheckEnableDisableForFields() {

    if (this.moduleConfigPropertiesDisplay[0] != undefined) {
      Object.entries(this.moduleConfigPropertiesDisplay[0]).forEach(([key, value]) => {
        const divElement = document.getElementById("SnapshotFields" + key);
        let values = value as string;
        if (divElement && values.toLowerCase() == "na") {
          divElement.classList.add("disabled");

          switch (key) {
            case "Sticky_Default_selection":
              {
                this.stickyDefaultSelection = [
                  { id: 1, selected: false, name: 'Sticky', value: 'sticky' },
                  { id: 2, selected: false, name: 'Default', value: 'default' },
                ];
                this.defaultStickyorDefault = "";
                this.stickyDefaultSelected = "";
              }
              break;
            case "Static_Text":
              this.defaultStaticTextAreaFlag = false;
              break;
            case "Reset_Selection":
              // this.defaultResetSelectionFlag = true;
              // this.resetSelectionFlag = true;            
              break;
            case "Output_Configuration":
              this.outputconfiguration = [
                { id: 1, selected: false, name: 'Admin Defined', value: 'admin' },
                { id: 2, selected: false, name: 'User Defined', value: 'user' },
              ];
              break;
            default:
              // Code for other keys
              break;
          }
        }
        else if (divElement) {
          divElement.classList.remove("disabled");
        }
        if (values != null) {
          if (values.toLowerCase() != "all" && values.toLowerCase() != "na") {
            switch (key) {
              case "Comparison_Points":
                let CP: any[] = [];
                let valuesAll = values.split(", ");
                valuesAll.forEach(a => {
                  this.comparisonPoints.forEach((element: any) => {
                    if (element.name == a)
                      CP.push(element)
                  });
                });
                this.comparisonPoints = CP;
                break;
              case "Export":
                this.export = [];
                let exportValuesAll = values.split(", ");
                exportValuesAll.forEach(a => { this.export.push({ id: 1, selected: false, name: a, value: a }) });
                break;
              case "Filter_Function":

                break;
              case "Multiple_Confidence_Levels":
                this.multipleConfidence = [];
                let multipleConfidenceValuesAll = values.split(", ");
                multipleConfidenceValuesAll.forEach(a => { this.multipleConfidence.push({ id: 1, selected: false, name: a, value: a }) });
                break;
              case "Output_Configuration":
                const index = this.outputconfiguration.findIndex(item => item.name === values);
                this.outputconfiguration = [];
                this.outputconfiguration.push({ id: index + 1, selected: true, name: values, value: values.split(" ")[0].toLowerCase() });

                break;
              case "Reset_Selection":
                {
                  const indexReset = this.reset.findIndex(item => item.name === values);
                  this.reset = [];
                  this.reset.push({ id: indexReset + 1, selected: true, name: values, value: values });

                  break;
                }
              case "Sticky_Default_selection":
                const indexSD = this.stickyDefaultSelection.findIndex(item => item.name === values);
                this.stickyDefaultSelection = [];
                this.stickyDefaultSelection.push({ id: indexSD + 1, selected: true, name: values, value: values });
                break;
              case "Types_of_Significance":
                this.significance = [];
                let significanceValuesAll = values.split(", ");
                significanceValuesAll.forEach(a => { this.significance.push({ id: 1, selected: false, name: a, value: a }) });
                break;

              default:
                // Code for other keys
                break;
            }
          }
        }
      });
    }
    setTimeout(() => {
      this._loaderService.hideLoader()
    }, 1000);
  }

  async GetClientExistingSnapshotData(
    clientCode: string,
    snapshotName: string
  ) {
    this.subscriptions.add(
      this._configService
        .getClientStudyData({
          client_code: clientCode,
          snapshot_name: snapshotName,
        })
        .subscribe(async (b) => {
          this._configService.alreadySavedSnapshotData = JSON.parse(b.body.Data);

          if (
            this._configService.alreadySavedSnapshotData != null &&
            this._configService.alreadySavedSnapshotData != undefined &&
            this._configService.alreadySavedSnapshotData != ''
          ) {
            this.snapshotData = this._configService.alreadySavedSnapshotData;
            if (this.snapshotData != undefined && this.snapshotData != null) {
              this.dataExistance = true;
              this._configService.clientSnapshotSelectedData = this.snapshotData;

              //await this.UpdateProductAndTemplate();

              this.AddAlreadyExistingData();

            } else {
              this.dataExistance = false;
            }
          } else {
            this.dataExistance = false;
          }
          this._configService.ifDataExists = this.dataExistance;
        }));
  }

  UpdateProductAndTemplate() {
    this._configService.productSelected = this.snapshotData.product;
    this._configService.templateSelected = this.snapshotData.product_type;
    this.CheckModuleConfigProperties();
  }

  showWidgetLayout() {
    this.errorheaderTitle = 'WidgetLayout';
    this.showPopUp = true;
    this.showErrorPopUp = false;
  }

  receiveLayoutWidget(message: string) {
    this.selectedwidget = message;
    const snapLayoutInput = document.querySelector(
      '.SnapshotFieldInputLayout'
    ) as HTMLElement;
    snapLayoutInput.innerHTML = this.selectedwidget;
  }

  onCloseIconClick(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.showPopUp = false;
      this.errorheaderTitle = '';
      this.showErrorPopUp = false;
      if (!this.showErrorPopUp && this.popUpTitle != "Error") {
        let data: {
          client_name: string;
          study: string;
          configdata: any;
        } = {
          client_name: this.clientDetails.clientDetails.client_name,
          study: this.clientDetails.clientDetails.study,
          configdata: this.clientDetails.clientDetails.configdata,
        };
        setTimeout(() => {
          this.router
            .navigateByUrl('Snapshot/snapshotpreview', {
              skipLocationChange: true,
            })
            .then(() => {
              this.router.navigateByUrl('Snapshot/configuaration', {
                state: data,
              });
            });
        }, 100);
      }
    }
  }

  addSnapshotTab() {
    const element = document.querySelector('.snapshot-button-area'); // Replace '.snapshot-create-btn' with the selector of your target element

    const inputElement = document.getElementById(
      'SnapshotNameFieldInput' + this.snapCountNum
    ) as HTMLInputElement;
    if (inputElement) {
      this.snapshotName = inputElement.value;
    }

    if (element) {
      const snapshotButton = document.createElement('div');
      snapshotButton.setAttribute('ngModel', this.snapCountNum.toString());

      snapshotButton.className = 'snapshot-create-button';
      snapshotButton.title = this.snapshotName;
      snapshotButton.id = 'snapshot' + this.snapCountNum;
      snapshotButton.style.cssText =
        'color: white;background: linear-gradient(90deg, #8600CD 0%, #1110EB 100%);border: 1px solid #8029B6; border-radius: 0.375rem; display: flex; align-items: center; justify-content: space-evenly; cursor: pointer; width: 8.5rem; height: 100%; margin-right: 1rem;';

      snapshotButton.addEventListener('click', () => {
        const clickedElementId = snapshotButton.id;
        const snapshotId = clickedElementId.split('snapshot')[1];
        this.snapshotCount.snapshotCount = parseInt(snapshotId);
        this.id = parseInt(snapshotId);
      });

      const btnIcon = document.createElement('div');
      btnIcon.className = 'btn-icon';
      btnIcon.style.cssText =
        'color: #8029B6; align-items: center; display: flex;';

      const materialSymbol = document.createElement('span');
      materialSymbol.style.cssText = 'display:flex;';
      materialSymbol.innerHTML =
        '<img src=' +
        (true
          ? 'assets/ImagesSnapshot/Public/snapshot_icon_white.svg'
          : 'assets/ImagesSnapshot/Public/snapshot_icon_purpl.svg') +
        '>';

      const btnText = document.createElement('div');
      btnText.className = 'btn-text';
      btnText.style.cssText =
        'align-items: center; font-size: 0.75rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;';
      btnText.textContent = this.snapshotName;
      btnIcon.appendChild(materialSymbol);
      snapshotButton.appendChild(btnIcon);
      snapshotButton.appendChild(btnText);
      element.appendChild(snapshotButton);
      this._configService.ifDataExists = true;
    }
  }

  showStaticTextArea(event: Event) {
    this.showStaticTextAreaFlag = true;
  }

  hideStaticTextArea(event: Event) {
    this.showStaticTextAreaFlag = false;
  }
  entryPointsData: any;
  aggregatedVariables: any;
  getSelectedValueStudyName(option: any, value: string): void {
    // For multiple select checkboxes
    this.checkedList = []; // single select

    this.studyNames.forEach((study: any) => {
      study.selected = false;
    })
    const studyNameRadios = document.getElementsByClassName('studyNameRadio');
    for (let i = 0; i < studyNameRadios.length; i++) {
      const radio = studyNameRadios[i] as HTMLInputElement;
      radio.checked = false;
    }
    this.clientDetails.clientDetails.selectedStudy = option.name;
    option.selected = option.selected == null ? true : !option.selected;
    if (option.selected) {
      // If checkbox is checked, add value to checkedList
      this.checkedList.push(value);
    } else {
      // If checkbox is unchecked, remove value from checkedList
      const index = this.checkedList.indexOf(value);
      if (index !== -1) {
        this.checkedList.splice(index, 1);
      }
    }
    this.FilterEPandDimData();

  }

  async getStudyDetails() {
    let parameter = {
      snapshot_name: this.clientDetails.clientDetails.study,
      client_name: this.clientDetails.clientDetails.client_name,
      client_code: this.clientDetails.clientDetails.client_name,
    };
    this._configService
      .getSnapshotEntryPointData(parameter)
      .subscribe((data) => {
        this._loaderService.showLoader();
        this.entryPointsData = JSON.parse(data.Data);
        this.snapshotData = this.entryPointsData.filter(
          (x: any) => x.study === this.clientDetails.clientDetails.selectedStudy
        )[0];
        // this.snapshotDataConfig = this.snapshotData.snap_config;
        // //this.selectedWeight=this.snapshotData.
        this.aggregatedVariables = this.snapshotData.aggregatedvariables;
        var x = [];
        for (let i = 0; i < this.snapshotData.dataformat.length; i++) {
          if (this.snapshotData.dataformat[i].value == true) {
            x.push(this.snapshotData.dataformat[i].key);
          }
        }

        for (let j = 0; j < x.length; j++) {
          if (x[j] == 'Respondent Level') {
            this._configService.isRespondentLevel = true;
            this._configService.isSemiAggregatedData = false;
            this._configService.isAggregatedData = false;
          }
          else if (x[j] == 'Semi-Aggregated') {
            this._configService.isSemiAggregatedData = true;
            this._configService.isAggregatedData = false;
            this._configService.isRespondentLevel = false;

          }
          else if (x[j] == 'Aggregated') {
            this._configService.isAggregatedData = true;
            this._configService.isRespondentLevel = false;
            this._configService.isSemiAggregatedData = false;
          }
        }

        // ;
        this.cdr.detectChanges();
        this._loaderService.hideLoader();
      });
  }

  FilterEPandDimData() {
    if (this.data.length != 0) {
      this.snapshotDetails.dimensionsDetails = [];
      this.snapshotDetails.entryPointsDetails = [];
      if (this.checkedList.length != 0 && this.checkedList.length > 1) {
        for (let i = 0; i < this.data.length; i++) {
          for (
            let j = 0;
            j < this.data[i].configData.entry_point?.length;
            j++
          ) {
            this.snapshotDetails.entryPointsDetails.push(
              {
                "code": this.data[i].configData.entry_point[j].variable_code,
                "label": this.data[i].configData.entry_point[j].variable_label
              }
            );
          }
          for (let k = 0; k < this.data[i].configData.dimension?.length; k++) {
            this.snapshotDetails.dimensionsDetails.push(
              {
                "code": this.data[i].configData.dimension[k].variable_code,
                "label": this.data[i].configData.dimension[k].variable_label
              }
            );
          }
        }
        // Get unique dimensions
        this.snapshotDetails.dimensionsDetails = Array.from(
          new Set(this.snapshotDetails.dimensionsDetails)
        );
        // Get unique entry points
        this.snapshotDetails.entryPointsDetails = Array.from(
          new Set(this.snapshotDetails.entryPointsDetails)
        );
      } else if (this.checkedList.length == 1) {
        let nameOfStudySelected = this.checkedList[0];
        let filteredData = this.data.filter(
          (item: any) => item.configData?.study === nameOfStudySelected
        );

        for (
          let j = 0;
          j < filteredData[0].configData.entry_point.length;
          j++
        ) {
          this.snapshotDetails.entryPointsDetails.push(
            {
              "code": filteredData[0].configData.entry_point[j].variable_code,
              "label": filteredData[0].configData.entry_point[j].variable_label
            }
          );
        }
        for (let k = 0; k < filteredData[0].configData.dimension.length; k++) {
          this.snapshotDetails.dimensionsDetails.push(
            {
              "code": filteredData[0].configData.dimension[k].variable_code,
              "label": filteredData[0].configData.dimension[k].variable_label
            }
          );
        }
      } else {
        this.snapshotDetails.entryPointsDetails = [
          { variable_label: '', is_selected: false, variable_code: '' },
        ];
        this.snapshotDetails.dimensionsDetails = [
          { variable_label: '', is_selected: false, variable_code: '' },
        ];
      }
      this.PopulateEntryPointsAndDimensions();
    }
  }

  outputconfigchecked(item: any) {
    this.outputconfiguration.forEach((element: any) => {
      if (item === element) {
        element.selected = true;
        this.outputConfig = element.value;
      } else {
        element.selected = false;
      }
    });
  }

  stickyDefaultchecked(item: any) {
    this.stickyDefaultSelection.forEach((element: any) => {
      if (item === element) {
        element.selected = true;
        this.stickyDefaultSelected = element.value;
      } else {
        element.selected = false;
      }
    });
  }

  saveSelectionChecked(item: any, event: any) {
    this.checkBoxClick(item, event, this.saveSelection, this.saveSelectionCheckedList)
  }
  userManagementchecked(item: any, event: any) {
    this.checkBoxClick(item, event, this.userManagementSelection, this.userManagementCheckedList)
  }

  additionalCheckBoxchecked(item: any, event: any) {
    if(event.target.checked && item.name == "Static Time Frame") {
      sessionStorage.setItem('isSTF','true');
      this.isStaticTimeFrame = true;
      this._configService.isStaticTimeFrame = true;
      
      // if(this.isPreviousPeriosOrYear){
      //   this.uncheckOnError(item, event);
      //   this.errorPopup("Significance with respect to timeperiod cannot be selected with static time frame.", 'Alert');
      //   return;
      // }

      const conflictSelected = this.comparisonPoints.some(point =>
        (point.value === 'previousYear' || point.value === 'previousPeriod') && point.selected
      );
  
      if (conflictSelected) {
        this.uncheckOnError(item, event);
        this.errorPopup("Significance with respect to timeperiod cannot be selected with static time frame.", 'Alert');
        return;
      }
      const isReferenceSelected = this.comparisonPoints.some(point => 
        point.value === 'reference' && point.selected);
      
      if(isReferenceSelected) {
        // No popup needed for Reference with STF
      }
    }
    else if(!event.target.checked && item.name == "Static Time Frame") {
      this.isStaticTimeFrame = false;
      this._configService.isStaticTimeFrame = false;
      sessionStorage.setItem('isSTF','')
    }
    
    this.checkBoxClick(item, event, this.additionalCheckBoxSelection, this.additionalCheckBoxCheckedList);
  }
  
  customContentChecked(item: any, event: any) {
    this.checkBoxClick(item, event, this.customContentSelection, this.customContentCheckedList)
  }

  checkBoxClick(item: any, event: any, Selection: any, SelectionCheckedList: any, uncheckError: boolean = false) {
    Selection.forEach((i: any) => {
      if (event.target.checked && !uncheckError) {
        if (i == item) {
          i.selected = true;
          const existingItem = SelectionCheckedList.find(
            (j: any) => j.key === i.name
          );
          if (!existingItem) {
            SelectionCheckedList.push({
              key: i.name,
              value: i.selected,
            });
          }
        }
      } else {
        if (i == item) {
          i.selected = false;
          // Update the array without reassigning
          const index = SelectionCheckedList.findIndex(
            (j: any) => j.key === item.name
          );
          if (index > -1) {
            SelectionCheckedList.splice(index, 1); // Remove the unchecked item
          }
        }
      }
    });
  }
  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }
  
  isPreviousPeriosOrYear:boolean=false;
  comparisionChecked(item: any, event: any) {
    let isSTF =   sessionStorage.getItem('isSTF') == "true";

    if (event.target.checked) {
      this.lastSelectedOption = item;
      this.lastSelectedType = 'Comparison';
    }
  
    this.comparisonPoints.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          // Check for Previous Year or Previous Period with STF
          if ((i.value === 'previousYear' || i.value === 'previousPeriod')) {
            this.isPreviousPeriosOrYear = true;
            if (this.isStaticTimeFrame || isSTF) {
              this.uncheckOnError(item, event);
              this.errorPopup("Significance with respect to timeperiod cannot be selected with static time frame.", 'Alert');
              return;
            }
          }
          i.selected = true;
          this.comparisionCheckedList.push({
            key: i.name,
            value: i.selected,
          });
          
          // No popup needed for Reference with STF - even if STF was selected first
          if (i.value === 'reference' && this.isStaticTimeFrame) {
            // No popup
          }
        }
      } else {
        if (i == item) {
          if ((i.value === 'previousYear' || i.value === 'previousPeriod')) {
            // Check if any other Previous Year or Period is still selected
            const anyOtherPrevSelected = this.comparisonPoints.some(
              cp => cp !== item && 
                   (cp.value === 'previousYear' || cp.value === 'previousPeriod') && 
                   cp.selected
            );
            this.isPreviousPeriosOrYear = anyOtherPrevSelected;
          }
          i.selected = false;
          this.comparisionCheckedList = this.comparisionCheckedList.filter(
            (j: any) => j !== i
          );
        }
        this.comparisionCheckedList = this.comparisionCheckedList.filter(
          (j: any) => j.key !== item.name
        );
      }
    });
  }

  // comparisionChecked(item: any, event: any) {
  //   if (event.target.checked) {
  //     this.lastSelectedOption = item;
  //     this.lastSelectedType = 'Comparison';
  //   }
  
  //   this.comparisonPoints.forEach((point: any) => {
  //     if (point === item) {
  //       if (event.target.checked) {
  //         // Conflict check: Selecting Previous Year or Period while STF is active
  //         if ((point.value === 'previousYear' || point.value === 'previousPeriod')) {
  //           this.isPreviousPeriosOrYear = true;
  
  //           if (this.isStaticTimeFrame) {
  //             this.uncheckOnError(item, event);
  //             this.errorPopup(
  //               "Significance with respect to timeperiod cannot be selected with static time frame.",
  //               'Alert'
  //             );
  //             return;
  //           }
  //         }
  
  //         point.selected = true;
  //         this.comparisionCheckedList.push({
  //           key: point.name,
  //           value: point.selected,
  //         });
  
  //         // No popup needed for reference
  //       } else {
  //         // Unchecking logic
  //         point.selected = false;
  
  //         if (point.value === 'previousYear' || point.value === 'previousPeriod') {
  //           const anyOtherPrevSelected = this.comparisonPoints.some(cp =>
  //             cp !== item &&
  //             (cp.value === 'previousYear' || cp.value === 'previousPeriod') &&
  //             cp.selected
  //           );
  //           this.isPreviousPeriosOrYear = anyOtherPrevSelected;
  //         }
  
  //         this.comparisionCheckedList = this.comparisionCheckedList.filter(
  //           (j: any) => j.key !== item.name
  //         );
  //       }
  //     }
  //   });
  // }
  
  signiFicanceTypeChecked(item: any, event: any) {
    this.significance.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          i.selected = true;
          this.significanceTypeCheckedList.push(i);
        }
      } else {
        if (i == item) {
          i.selected = false;
          this.significanceTypeCheckedList =
            this.significanceTypeCheckedList.filter((j: any) => j !== i);
          this.significanceTypeCheckedList =
            this.significanceTypeCheckedList.filter(
              (j: any) => j.key !== i.name
            );
        }
      }
    });
  }

  multipleConfidenceChecked(item: any, event: any) {
    this.multipleConfidence.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          i.selected = true;
          this.multipleConfidenceCheckedList.push(i);
        }
      } else {
        if (i == item) {
          i.selected = false;
          this.multipleConfidenceCheckedList =
            this.multipleConfidenceCheckedList.filter((j: any) => j !== i);
          this.multipleConfidenceCheckedList =
            this.multipleConfidenceCheckedList.filter(
              (j: any) => j.key != i.name
            );
        }
      }
    });

  }

  exportChecked(item: any, event: any) {
    this.export.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          i.selected = true;
          this.exportCheckedList.push(i);
        }
      } else {
        if (i == item) {
          i.selected = false;
          this.exportCheckedList = this.exportCheckedList.filter(
            (j: any) => j !== i
          );
          this.exportCheckedList = this.exportCheckedList.filter(
            (j: any) => j.key !== i.name
          );
        }
      }
    });
  }

  submit() {

    this.isSubmit = false; //disabling the submit button
    this._loaderService.showLoader();
    if (
      this.clientDetails.snapshotCount < 20 ||
      this.currentSnapshotList.includes(this.form?.get('snapshotName')?.value)
    ) {
      this.commonchartservice.updateStudyNames(
        this.studyNames
          .filter((item: any) => item.selected)
          .map((item: any) => item.name)
      );
      const numberOfWidgetsCount = this.numberOfWidget;
      const snapshotType =
        this.form?.get('snapshotType')?.value != null
          ? this.form?.get('snapshotType')?.value
          : '';
      const docFolderType =
        this.form?.get('docFolderType')?.value != null
          ? this.form?.get('docFolderType')?.value
          : '';
      const docFileType =
        this.form?.get('docFileType')?.value != null
          ? this.form?.get('docFileType')?.value
          : '';

      const snapshotName =
        this.form?.get('snapshotName')?.value != null
          ? this.form?.get('snapshotName')?.value
          : '';

      const snapshotTypeCheckboxes = document.getElementsByClassName(
        'snapshot-type-checkbox'
      );
      let snapshotTypeDetails = [];
      let snapshotTypeSelectedArray = [];
      for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
        let snapshotTypeCheckbox = snapshotTypeCheckboxes[
          i
        ] as HTMLInputElement;
        let chk = snapshotTypeCheckbox.querySelector(
          'input[type="checkbox"]'
        ) as HTMLInputElement;
        if (chk !== null && chk.checked) {
          let ep = this.GetSelectedEntryPoint(chk.nextSibling?.textContent);
          let d = this.GetSelectedDimension(chk.nextSibling?.textContent);
          snapshotTypeSelectedArray.push(chk.nextSibling?.textContent);
          snapshotTypeDetails.push({
            snapshot_name: snapshotName,
            snapshot_type: chk.nextSibling?.textContent,
            entry_point: ep,
            dimension: d,
          });
        }
      }

      if (
        this.validationsOfSnapShotConfiguration(
          snapshotName,
          6,
          'Snapshot Name'
        )
        && this.validationsOfSnapShotConfiguration(this.checkedList, 1, 'Study Name') &&
        this.validationsOfSnapShotConfiguration(
          snapshotTypeSelectedArray,
          1,
          'Snapshot Type'
        ) &&
        // (this._configService.productSelected == "Standard" || this.validationsOfSnapShotConfiguration(
        //   numberOfWidgetsCount,
        //   1,
        //   'Number of Widgets'
        // )) &&
        ((!this.showStaticTextAreaFlag) || // Check if showStaticTextAreaFlag is false
          (this.showStaticTextAreaFlag &&
            this.validationsOfSnapShotConfiguration(
              this.statictext,
              1,
              'Static Text'
            ))) && // Check if showStaticTextAreaFlag is true and validate statictext
        ((this.comparisionCheckedList.length == 0 &&
          this.significanceTypeCheckedList.length == 0 &&
          this.multipleConfidenceCheckedList.length == 0) ||
          (this.comparisionCheckedList.length > 0 &&
            this.significanceTypeCheckedList.length > 0 &&
            this.multipleConfidenceCheckedList.length > 0) ||
          (this.validationsOfSnapShotConfiguration(
            this.comparisionCheckedList,
            1,
            'Comparision Points'
          ) &&
            this.validationsOfSnapShotConfiguration(
              this.significanceTypeCheckedList,
              1,
              'Types of Significance'
            ) &&
            this.validationsOfSnapShotConfiguration(
              this.multipleConfidenceCheckedList,
              1,
              'Multiple Confidence Levels'
            ))) &&
        this.CheckSnapshotNameDuplicate(snapshotName)
        // &&
        // this.validationsOfSnapShotConfiguration(
        //   this.exportCheckedList,
        //   1,
        //   'Export'
        // )
      ) {
        // this._loaderService.showLoader();
        this.showPopUp = false;
        //this.showErrorPopUp = true;
        //this.errorheaderTitle = "  ";
        this.popUpTitle = "  ";
        this.popUpMessage = "";
        this.snapCountNum = this.snapshotCount.snapshotCount;
        this.isSubmitted.emit(true);

        let studyList = [];
        this._configService.clientSnapshotAllStudyNames = [];
        for (let i = 0; i < this.studyNames.length; i++) {
          if (this.checkedList.includes(this.studyNames[i].name)) {
            studyList.push({
              study_id: (i + 1).toString(),
              study_name: this.studyNames[i].name,
            });


            this._configService.clientSnapshotAllStudyNames.push({
              label: this.studyNames[i].name,
              value: this.studyNames[i].name
            });
          }
        }



        let outputConfigValue = '';
        const outputConfigRadios = document.querySelectorAll(
          "#outputconfiguration input[type='radio']"
        );
        outputConfigRadios.forEach((radio: any) => {
          if (radio.checked) {
            outputConfigValue = radio.value;
          }
        });

        let significance_type = [];
        for (let i = 0; i < this.significanceTypeCheckedList.length; i++) {
          if (this.significanceTypeCheckedList[i].name != undefined)
            significance_type.push({
              value: this.significanceTypeCheckedList[i].selected,
              key: this.significanceTypeCheckedList[i].name,
            });
          else {
            significance_type.push({
              value: this.significanceTypeCheckedList[i].value,
              key: this.significanceTypeCheckedList[i].key,
            });
          }
        }

        let multipleConfidence_CheckedList = [];
        for (let i = 0; i < this.multipleConfidenceCheckedList.length; i++) {
          if (this.multipleConfidenceCheckedList[i].name != undefined)
            multipleConfidence_CheckedList.push({
              value: this.multipleConfidenceCheckedList[i].selected,
              key: this.multipleConfidenceCheckedList[i].name,
            });
          else {
            multipleConfidence_CheckedList.push({
              value: this.multipleConfidenceCheckedList[i].value,
              key: this.multipleConfidenceCheckedList[i].key,
            });
          }
        }

        let comparision_CheckedList = [];
        for (let i = 0; i < this.comparisionCheckedList.length; i++) {
          if (this.comparisionCheckedList[i].key != undefined)
            comparision_CheckedList.push({
              value: this.comparisionCheckedList[i].value,
              key: this.comparisionCheckedList[i].key,
            });
          // else{
          //   comparision_CheckedList.push({
          //     value: this.comparisionCheckedList[i].value,
          //     key: this.comparisionCheckedList[i].key,
          //   });
          // }
        }

        let export_CheckedList = [];
        for (let i = 0; i < this.exportCheckedList.length; i++) {
          if (this.exportCheckedList[i].name != undefined)
            export_CheckedList.push({
              value: this.exportCheckedList[i].selected,
              key: this.exportCheckedList[i].name,
            });
          else {
            export_CheckedList.push({
              value: this.exportCheckedList[i].value,
              key: this.exportCheckedList[i].key,
            });
          }
        }

        let saveSelection_CheckedList = [];
        for (let i = 0; i < this.saveSelectionCheckedList.length; i++) {
          if (this.saveSelectionCheckedList[i].name != undefined)
            saveSelection_CheckedList.push({
              value: this.saveSelectionCheckedList[i].selected,
              key: this.saveSelectionCheckedList[i].name,
            });
          else {
            saveSelection_CheckedList.push({
              value: this.saveSelectionCheckedList[i].value,
              key: this.saveSelectionCheckedList[i].key,
            });
          }
        }


        let custom_CheckedList = [];
        for (let i = 0; i < this.customContentCheckedList.length; i++) {
          if (this.customContentCheckedList[i].name != undefined)
            custom_CheckedList.push({
              value: this.customContentCheckedList[i].selected,
              key: this.customContentCheckedList[i].name,
            });
          else {
            custom_CheckedList.push({
              value: this.customContentCheckedList[i].value,
              key: this.customContentCheckedList[i].key,
            });
          }
        }

        let usermanagement_CheckedList = [];
        for (let i = 0; i < this.userManagementCheckedList.length; i++) {
          if (this.userManagementCheckedList[i].name != undefined)
            usermanagement_CheckedList.push({
              value: this.userManagementCheckedList[i].selected,
              key: this.userManagementCheckedList[i].name,
            });
          else {
            usermanagement_CheckedList.push({
              value: this.userManagementCheckedList[i].value,
              key: this.userManagementCheckedList[i].key,
            });
          }
        }

        let additional_CheckedList = [];
        for (let i = 0; i < this.additionalCheckBoxCheckedList.length; i++) {
          if (this.additionalCheckBoxCheckedList[i].name != undefined)
            additional_CheckedList.push({
              value: this.additionalCheckBoxCheckedList[i].selected,
              key: this.additionalCheckBoxCheckedList[i].name,
            });
          else {
            additional_CheckedList.push({
              value: this.additionalCheckBoxCheckedList[i].value,
              key: this.additionalCheckBoxCheckedList[i].key,
            });
          }
        }

        let mode = this.dataExistance ? 'Update' : 'Insert';
        let resetSel = (
          document.querySelector(
            '.reset-sel input[type="radio"]:checked'
          ) as HTMLInputElement
        )?.value;
        // this.resetSelectionFlag =
        //   resetSel.toLowerCase() == 'yes' ? true : false;
        let snapshotLayout = Number(
          this.selectedwidget.replace(' Widget Layout', '')
        );

        let dataObject = {         
          configData: {
            client_code: this.clientDetails.clientDetails.client_name,
            client_name: this.clientDetails.clientDetails.client_name,
            product: this._configService.productSelected,
            product_type: this._configService.templateSelected,
            snapshot_name: snapshotName,
            snapshotType_details: snapshotTypeDetails,
            study_list: studyList,
            number_of_widgets: numberOfWidgetsCount,
            snapshot_layout: snapshotLayout.toString(),
            is_output_configuration:
              outputConfigValue.toLowerCase() == 'admin' ? true : false,
            is_answer_base: this.answerBaseInput,
            is_static_text_enable: this.showStaticTextAreaFlag,
            static_text: this.showStaticTextAreaFlag ? this.statictext : "",
            significance_type: significance_type,
            confidence_level: multipleConfidence_CheckedList,
            is_reset_selections: this.resetSelectionFlag,
            sticky_selection_type: this.stickyDefaultSelected,
            sig_testing_vs: comparision_CheckedList,
            export_download: export_CheckedList,
            widget_detail: [],
            saveselection: saveSelection_CheckedList,
            custom_content: custom_CheckedList,
            user_management: usermanagement_CheckedList,
            additional_list: additional_CheckedList
          },
          mode: mode,
        };


        this._configService.noOfWidget(dataObject.configData.number_of_widgets);
        this._configService.widgetDivs(dataObject.configData.snapshot_layout);

        this.subscriptions.add(
          this._configService
            .addSnapshotConfiguration(dataObject)
            .subscribe((a) => {
              //this.showErrorPopUp=false;

              if (a.body.Data == '"Saved Successfully"') {
                //this.showPopUp = false;
                //this.showErrorPopUp = true;
                //this.errorheaderTitle = "Success";
                //this.showErrorPopUp = true;
                this.popUpTitle = "Success";
                this.popUpMessage = 'Submitted Successfully';
                this.clientDetails.clientDetails.configdata.forEach(
                  (element: any) => {
                    if (
                      element.ClientName ==
                      this.clientDetails.clientDetails.client_name
                    ) {
                      if (element.UniqueSnapshots != undefined) {
                        element.UniqueSnapshots.push(snapshotName);
                      } else {
                        element.UniqueStudies.push(snapshotName);
                      }
                    }
                  }
                );
                this.clientDetails.snapshotCount += 1;


                this.clientDetails.clientDetails.study = snapshotName;

              }
              else if (a.body.Data == '"Updated Successfully"') {
                //this.showPopUp = false;
                //this.showErrorPopUp = true;
                //this.showErrorPopUp = true;
                this.popUpTitle = "Info";
                this.popUpMessage = 'Updated Successfully';

              } else {
                //this.showErrorPopUp = true;
                //this.showErrorPopUp = true;
                this.errorheaderTitle = 'Error';
                this.popUpTitle = "Error";
                //this.showPopUp = false;
                this.popUpMessage = 'Failed to Submit:' + a.body.Data;
                this.clientDetails.clientDetails.study = "";
              }
              this.isSubmit = true;
              this.showSubmitPopUp = true;
              this.cdr.detectChanges();
              this._loaderService.hideLoader();
            }));
      } else {
        this.showPopUp = false;
        this.isSubmit = true;
        this.showErrorPopUp = true;
        this.popUpTitle = "Error";
        this.errorheaderTitle = 'Error';
        if (this.clientDetails.clientDetails.study == "") {
          this.clientDetails.clientDetails.study = "";
        }
        if (this.popUpMessage == "")
          this.popUpMessage = 'Validation Failed!';
      }
    } else {
      this.showPopUp = false;
      this.isSubmit = true;
      //this.showErrorPopUp = true;
      this.popUpTitle = "Error";
      this.errorheaderTitle = 'Error';
      this.popUpMessage =
        'Failed to Submit:' +
        'You have reached the maximum limit of 6 snapshots. Please delete an existing snapshot before adding a new one.';
    }
    this._loaderService.hideLoader();
  }

  validationsOfSnapShotConfiguration(
    item: any,
    minLength: number = 1,
    messageSwitch: any
  ) {
    //this.showErrorPopUp = true;
    if (Array.isArray(item) && item.length < minLength) {
      this.showValidationErrorMessage(messageSwitch);
      return false;
    } else if (!Array.isArray(item) && item.length < minLength) {
      // Handle non-array cases
      this.showValidationErrorMessage(messageSwitch);
      return false;
    } else {
      return true;
    }
  }

  showValidationErrorMessage(messageSwitch: any) {
    switch (messageSwitch) {
      case 'Snapshot Name': {
        this.popUpMessage =
          'Please enter the SNAPSHOT NAME of minimum 6 characters. ';
        break;
      }
      case 'Study Name': {
        this.popUpMessage =
          'Please select the field STUDY NAMES. ';
        break;
      }
      case 'Snapshot Type': {
        this.popUpMessage = 'Please select the field SNAPSHOT TYPE. ';
        break;
      }
      case 'Number of Widgets': {
        this.popUpMessage = 'Please select the field NUMBER OF WIDGETS. ';
        break;
      }
      case 'Static Text': {
        this.popUpMessage = 'Please enter the field STATIC TEXT. ';
        break;
      }
      case 'Comparision Points': {
        this.popUpMessage = 'Please select the field COMPARISION POINTS. ';
        break;
      }
      case 'Types of Significance': {
        this.popUpMessage = 'Please select the field TYPES OF SIGNIFICANCE. ';
        break;
      }
      case 'Multiple Confidence Levels': {
        this.popUpMessage =
          'Please select the field MULTIPLE CONFIDENCE LEVELS. ';
        break;
      }
      case 'Export': {
        this.popUpMessage = 'Please select the field EXPORT. ';
        break;
      }
      default:
        this.popUpMessage = 'Please enter all the fields...! ';
        break;
    }

    this.errorheaderTitle = 'Error';
  }

  SnapshotTypeClick(event: any, id: any) {
    const target = event.target as HTMLElement;
    const snapshotTypeCheckbox = target.closest('.snapshot-type-checkbox') as HTMLElement;
    const element = document.getElementById(id) as HTMLInputElement;
    const isChecked = element.checked;
    if (!isChecked) {
      const snapshotTypeCheckboxes = snapshotTypeCheckbox.querySelectorAll('input[type="checkbox"]');
      snapshotTypeCheckboxes.forEach((checkbox: any) => {
        if (checkbox.checked) {
          checkbox.checked = false;
        }
      });
    }
  }

  clearAll() {
    this.comparisionCheckedList = [];
    this.significanceTypeCheckedList = [];
    this.multipleConfidenceCheckedList = [];
    this.saveSelectionCheckedList = [];
    this.userManagementCheckedList = [];
    this.customContentCheckedList = [];
    this.exportCheckedList = [];
    this.checkedList = [];
    this.additionalCheckBoxCheckedList = [];
    this.comparisonPoints.forEach((item: any) => (item.selected = false));
    this.significance.forEach((item: any) => (item.selected = false));
    this.multipleConfidence.forEach((item: any) => (item.selected = false));
    this.saveSelection.forEach((item: any) => (item.selected = false));
    this.userManagementSelection.forEach((item: any) => (item.selected = false));
    this.customContentSelection.forEach((item: any) => (item.selected = false));
    this.export.forEach((item: any) => (item.selected = false));
    this.resetSelectionFlag = this.defaultResetSelectionFlag;
    this.outputConfig = this.defaultOutputConfig;
    this.stickyDefaultSelected = this.defaultStickyorDefault;
    this.selectedwidget = this.defaultselectedWidget;
    
    this.outputconfiguration = [
      { id: 1, selected: true, name: 'Admin Defined', value: 'admin' },
      { id: 2, selected: false, name: 'User Defined', value: 'user' },
    ];
    this.stickyDefaultSelection = [
      { id: 1, selected: true, name: 'Sticky', value: 'sticky' },
      { id: 2, selected: false, name: 'Default', value: 'default' },
    ];
    this.reset = [
      { id: 1, selected: this.resetSelectionFlag, name: 'Yes', value: 'yes' },
      { id: 2, selected: !this.resetSelectionFlag, name: 'No', value: 'no' },
    ];
    this.answerBaseInput = this.defaultAnswerBaseInput;
    this.showStaticTextAreaFlag = this.defaultStaticTextAreaFlag;
    // const snapLayoutInput = document.querySelector(
    //   '.SnapshotFieldInputLayout'
    // ) as HTMLElement;
    //snapLayoutInput.innerHTML = this.selectedwidget;
    this.studyNames.forEach((study: any) => (study.selected = false));
    this.numberOfWidget = this.snapshotData.number_of_widgets;

    // this.form.reset();
    const studyNameValue = this.form.get('snapshotName')?.value;
    ;
    if (this.clientDetails.clientDetails.study != '') {
      this.form.reset({
        snapshotName: studyNameValue,
      });
    } else {
      this.form.reset();
    }

    const snapshotTypeCheckboxes = document.getElementsByClassName(
      'snapshot-type-checkbox'
    );

    let snapshotTypeDetails = [];
    for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
      let snapshotTypeCheckbox = snapshotTypeCheckboxes[
        i
      ] as HTMLInputElement;
      let chk = snapshotTypeCheckbox.querySelector(
        'input[type="checkbox"]'
      ) as HTMLInputElement;

      if (chk !== null && chk.checked) {
        let ep = this.GetSelectedEntryPoint(chk.nextSibling?.textContent);
        let d = this.GetSelectedDimension(chk.nextSibling?.textContent);
        snapshotTypeDetails.push({
          snapshot_type: chk.nextSibling?.textContent,
          entry_point: ep,
          dimension: d,
        });
      }
    }


    let condition = this.dataExistance ? this.snapshotData?.snapshotType_details?.length : snapshotTypeDetails.length;
    for (let j = 0; j < condition; j++) {
      for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
        let snapshotTypeCheckbox = snapshotTypeCheckboxes[
          i
        ] as HTMLInputElement;
        let chk = snapshotTypeCheckbox.querySelector(
          'input[type="checkbox"]'
        ) as HTMLInputElement;

        chk.checked = false;
      }
    }

    // add the this.numberOfWidget value to the form with FormControlName as 'widgetTypeForm'
    this.form.controls['widgetTypeForm'].setValue(this.numberOfWidget);


    this.ClearAlreadySelectedDimensions();
    this.ClearAlreadySelectedEntryPoints();
    this.CheckEnableDisableForFields();

    this.entryPointsSB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsSB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.entryPointsMB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsMB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.entryPointsMC = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsMC = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.entryPointsMM = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsMM = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

  }

  //DELETE CONFIGURATION CODE:

  delete() {
    this.showDeletePopup = true;
  }
  receivedDeleteConfirmation(data: any) {

    this.showDeletePopup = false;
    if (data == 'yes') {
      //API CALL FOR DELETING
      this.subscriptions.add(
        this._configService
          .deleteSnapshot({
            client_code: this.clientDetails.clientDetails.client_name,
            snapshot_name: this.clientDetails.clientDetails.study,
          })
          .subscribe((res) => {

            if (res.Data == '"Deleted Successfully"') {
              const deletedElement = document.querySelector(
                '[title="' + this.clientDetails.clientDetails.study + '"'
              );
              if (deletedElement) deletedElement.remove();

              const navigationExtras = {
                state: {
                  deletedsnapshot: this.selectedSnapshotData.snapshotName,
                },
              };
              setTimeout(() => {
                this.router
                  .navigateByUrl('Snapshot/snapshotpreview', {
                    skipLocationChange: true,
                  })
                  .then(() => {
                    this.router.navigateByUrl(
                      'Snapshot/configuaration',
                      navigationExtras
                    );
                  });
              }, 100);
            }
          }));
      this.subscriptions.add(
        this._configService.deleteWidget({
          clientName: this.clientDetails.clientDetails.client_name,
          snapshotName: this.clientDetails.clientDetails.study,
        }).subscribe((res) => {

        }))
    }
    // });
    //}
  }

  //------------------------

  save() { }
  isStaticTimeFrame:boolean=false;
  AddAlreadyExistingData() {
    this.alreadyExisting.emit(true);
    this.form.controls['snapshotName'].setValue(
      this.snapshotData.snapshot_name
    );
    //this.form.controls['snapshotType'].setValue(this.snapshotData.snapshotType_details[0].snapshot_type);
    const studyNamesArea = document.getElementById(
      'studyNamesArea'
    ) as HTMLSpanElement;
    this.checkedList = this.snapshotData.study_list.map(
      (study: any) => study.study_name
    );
    this.FilterEPandDimData();

    if (studyNamesArea) {
      studyNamesArea.innerHTML =
        this.snapshotData.study_list.length > 0 ? this.checkedList : 'Select';
    }

    this._configService.clientSnapshotAllStudyNames = [];
    for (let i = 0; i < this.studyNames.length; i++) {
      if (this.checkedList.includes(this.studyNames[i].name)) {
        this._configService.clientSnapshotAllStudyNames.push({
          label: this.studyNames[i].name,
          value: this.studyNames[i].name
        });
        this.studyNames[i].selected = true;
        this.clientDetails.clientDetails.selectedStudy = this.studyNames[i].name;
      }
    }
    //this.form.controls['studyName'].setValue(this.snapshotData.study_list);
    this.form.controls['staticText'].setValue(this.snapshotData.static_text);
    this.selectedwidget = this.snapshotData.snapshot_layout + ' Widget Layout';
    // const snapLayoutInput = document.querySelector(
    //   '.SnapshotFieldInputLayout'
    // ) as HTMLElement;
    // snapLayoutInput.innerHTML = this.selectedwidget;

    this.snapshotLayout = this.snapshotData.snapshot_layout;
    this.numberOfWidget = this.snapshotData.number_of_widgets;
    // this.numberOfWidget = 0;

    this.showStaticTextAreaFlag = this.snapshotData.is_static_text_enable;
    this.answerBaseInput = this.snapshotData.is_answer_base;
    this.outputConfig = this.snapshotData.is_output_configuration
      ? 'admin'
      : 'user';
    this.stickyDefaultSelected = this.snapshotData.sticky_selection_type;
    this.resetSelectionFlag = this.snapshotData.is_reset_selections;
    this.comparisionCheckedList = this.snapshotData.sig_testing_vs;
    this.significanceTypeCheckedList = this.snapshotData.significance_type;
    this.multipleConfidenceCheckedList = this.snapshotData.confidence_level;
    this.saveSelectionCheckedList = this.snapshotData.saveselection;
    this.additionalCheckBoxCheckedList = this.snapshotData.additional_list;
    this.customContentCheckedList = this.snapshotData.custom_content;
    this.userManagementCheckedList = this.snapshotData.user_management;
    this.exportCheckedList = this.snapshotData.export_download;
    this.statictext = this.snapshotData.static_text;

    this.studyNames.forEach((item: any) => {
      this.checkedList.forEach((element: any) => {
        if (item.name == element) {
          item.selected = element.value;
        }
      });
    });


    this.comparisonPoints.forEach((item: any) => {
      this.comparisionCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });

    this.significance.forEach((item: any) => {
      this.significanceTypeCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.multipleConfidence.forEach((item: any) => {
      this.multipleConfidenceCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.saveSelection.forEach((item: any) => {
      this.saveSelectionCheckedList?.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.export.forEach((item: any) => {
      this.exportCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.userManagementSelection.forEach((item: any) => {
      this.userManagementCheckedList?.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.customContentSelection.forEach((item: any) => {
      this.customContentCheckedList?.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.isStaticTimeFrame=false;
    this._configService.isStaticTimeFrame=false;
    this.additionalCheckBoxSelection.forEach((item: any) => {
      this.additionalCheckBoxCheckedList?.forEach((element: any) => {
        if (item.name == element.key) {
          if(item.name == 'Static Time Frame'){
            this.isStaticTimeFrame=true;
            this._configService.isStaticTimeFrame=true;
            sessionStorage.setItem('isSTF', 'true');
          }
          item.selected = element.value;
        }
      });
    });
    this.outputconfiguration.forEach((item: any) => {
      if (item.value == this.outputConfig) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
    this.stickyDefaultSelection.forEach((item: any) => {
      if (item.value == this.stickyDefaultSelected) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });

    this.reset.forEach((item: any) => {
      if (item.value?.toLowerCase() == (this.resetSelectionFlag == true ? 'yes' : 'no')) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });

    const snapshotTypeCheckboxes = document.getElementsByClassName(
      'snapshot-type-checkbox'
    );
    for (let j = 0; j < this.snapshotData?.snapshotType_details?.length; j++) {
      for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
        let snapshotTypeCheckbox = snapshotTypeCheckboxes[
          i
        ] as HTMLInputElement;
        let chk = snapshotTypeCheckbox.querySelector(
          'input[type="checkbox"]'
        ) as HTMLInputElement;
        let label = snapshotTypeCheckbox.querySelector(
          'label'
        ) as HTMLLabelElement | null;

        if (
          label &&
          label.innerText ===
          this.snapshotData.snapshotType_details[j].snapshot_type
        ) {
          chk.checked = true;
        }
      }
    }

    ;
    this._configService.noOfWidget(this.numberOfWidget);
    this._configService.widgetDivs(this.snapshotLayout);
    ;
    this.AddAlreadySelectedEP(this.snapshotData.snapshotType_details);
    this.AddAlreadySelectedDim(this.snapshotData.snapshotType_details);

    // this.addSnapshotTab();
  }

  StudytypeExpandClicks(event: Event) {
    let id = (event.target as HTMLElement).id;

    const expandIcon = document.getElementById(id) as HTMLElement;

    const expandIconSelected = document.querySelector('.expand-icon.selected');
    if (expandIconSelected && expandIconSelected.id != id) {
      expandIconSelected.classList.remove('selected');
    }

    if (expandIcon) {
      expandIcon.classList.toggle('selected');
    }

    if (id.includes('singleBrand')) {
      this.showSingleBrand = !this.showSingleBrand;
      this.showMultiBrand = false;
      this.showMultiCategory = false;
      this.showMultiMarket = false;
    } else if (id.includes('multiBrand')) {
      this.showMultiBrand = !this.showMultiBrand;
      this.showSingleBrand = false;
      this.showMultiCategory = false;
      this.showMultiMarket = false;
    } else if (id.includes('multiCategory')) {
      this.showMultiCategory = !this.showMultiCategory;
      this.showSingleBrand = false;
      this.showMultiBrand = false;
      this.showMultiMarket = false;
    } else if (id.includes('multiMarket')) {
      this.showMultiMarket = !this.showMultiMarket;
      this.showSingleBrand = false;
      this.showMultiBrand = false;
      this.showMultiCategory = false;
    }
  }

  ExportEntryPointsClicks(val: any, entryPoints: any, event: any) {
    entryPoints.forEach((i: any) => {
      let id = (event.target as HTMLElement).id;
      if (event.target.checked) {
        if (i == val) {
          i.is_selected = true;
          i.variable_label = id;
          this.exportEntryPoints.push(i);
        }
      } else {
        if (i == val) {
          i.is_selected = false;
          i.variable_label = id;
          this.exportEntryPoints = this.exportEntryPoints.filter(
            (j: any) => j !== i
          );
        }
      }
    });
    let a = event.target.closest('.snapshot-type-checkbox');
    let checkBox = a.querySelector('input[type="checkbox"]');
    if (!checkBox.checked) {
      checkBox.checked = true;
    }
  }

  ExportDimensionsClicks(val: any, dimensions: any, event: any) {
    dimensions.forEach((i: any) => {
      if (event.target.checked) {
        if (i == val) {
          i.is_selected = true;
          this.exportDimensions.push(i);
        }
      } else {
        if (i == val) {
          i.is_selected = false;
          this.exportDimensions = this.exportDimensions.filter(
            (j: any) => j !== i
          );
        }
      }
    });
    let a = event.target.closest('.snapshot-type-checkbox');
    let checkBox = a.querySelector('input[type="checkbox"]');
    if (!checkBox.checked) {
      checkBox.checked = true;
    }
  }

  GetSelectedEntryPoint(snapshot_type: any) {
    let ep: any[] = [];
    switch (snapshot_type) {
      case 'Single Brand': {
        ep = this.entryPointsSB.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
      case 'Multiple Brands': {
        ep = this.entryPointsMB.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
      case 'Multiple Categories': {
        ep = this.entryPointsMC.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
      case 'Multiple Markets': {
        ep = this.entryPointsMM.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
    }
    return ep;
  }

  GetSelectedDimension(snapshot_type: any) {
    let d: any[] = [];
    switch (snapshot_type) {
      case 'Single Brand': {
        d = this.dimensionsSB.filter((dimension: any) => dimension.is_selected);
        break;
      }
      case 'Multiple Brands': {
        d = this.dimensionsMB.filter((dimension: any) => dimension.is_selected);
        break;
      }
      case 'Multiple Categories': {
        d = this.dimensionsMC.filter((dimension: any) => dimension.is_selected);
        break;
      }
      case 'Multiple Markets': {
        d = this.dimensionsMM.filter((dimension: any) => dimension.is_selected);
        break;
      }
    }
    return d;
  }

  PopulateEntryPointsAndDimensions() {

    this.entryPointsSB = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {

        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

    this.dimensionsSB = this.snapshotDetails.dimensionsDetails.map(
      (dimension: any, index: number) => {
        return {
          variable_label: dimension.label,
          is_selected: false,
          variable_code: dimension.code,
        };
      }
    );

    this.entryPointsMB = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {
        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

    this.dimensionsMB = this.snapshotDetails.dimensionsDetails.map(
      (dimension: any, index: number) => {
        return {
          variable_label: dimension.label,
          is_selected: false,
          variable_code: dimension.code,
        };
      }
    );
    this.entryPointsMC = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {
        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

    this.dimensionsMC = this.snapshotDetails.dimensionsDetails.map(
      (dimension: any, index: number) => {
        return {
          variable_label: dimension.label,
          is_selected: false,
          variable_code: dimension.code,
        };
      }
    );
    this.entryPointsMM = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {
        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

    this.dimensionsMM = this.snapshotDetails.dimensionsDetails.map(
      (dimension: any, index: number) => {
        return {
          variable_label: dimension.label,
          is_selected: false,
          variable_code: dimension.code,
        };
      }
    );
  }

  AddAlreadySelectedEP(selectedEPs: any) {
    for (const selectedEP of selectedEPs) {
      const entryPoints = this.getEntryPointsBySnapshotType(
        selectedEP.snapshot_type
      );
      for (const entryPoint of selectedEP.entry_point) {
        const selectedVariableLabel = entryPoint.variable_label;
        const matchingEntryPoint = entryPoints.find(
          (ep) => ep.variable_label === selectedVariableLabel
        );
        if (matchingEntryPoint) {
          matchingEntryPoint.is_selected = entryPoint.is_selected;
        }
      }
    }
  }

  getEntryPointsBySnapshotType(snapshotType: string) {
    switch (snapshotType) {
      case 'Single Brand':
        return this.entryPointsSB;
      case 'Multiple Brands':
        return this.entryPointsMB;
      case 'Multiple Categories':
        return this.entryPointsMC;
      case 'Multiple Markets':
        return this.entryPointsMM;
      default:
        return [];
    }
  }

  ClearAlreadySelectedEntryPoints() {
    this.entryPointsSB.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });

    this.entryPointsMB.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });

    this.entryPointsMC.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });

    this.entryPointsMM.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });
  }

  ClearAlreadySelectedDimensions() {
    this.dimensionsSB.forEach((dimension: any) => {
      dimension.is_selected = false;
    });

    this.dimensionsMB.forEach((dimension: any) => {
      dimension.is_selected = false;
    });

    this.dimensionsMC.forEach((dimension: any) => {
      dimension.is_selected = false;
    });

    this.dimensionsMM.forEach((dimension: any) => {
      dimension.is_selected = false;
    });
  }

  AddAlreadySelectedDim(selectedDims: any) {
    for (const selectedDim of selectedDims) {
      const dimensions = this.getDimensionsBySnapshotType(
        selectedDim.snapshot_type
      );
      for (const dimension of selectedDim.dimension) {
        const selectedVariableLabel = dimension.variable_label;
        const matchingDimension = dimensions.find(
          (dim) => dim.variable_label === selectedVariableLabel
        );
        if (matchingDimension) {
          matchingDimension.is_selected = dimension.is_selected;
        }
      }
    }
  }

  getDimensionsBySnapshotType(snapshotType: string) {
    switch (snapshotType) {
      case 'Single Brand':
        return this.dimensionsSB;
      case 'Multiple Brands':
        return this.dimensionsMB;
      case 'Multiple Categories':
        return this.dimensionsMC;
      case 'Multiple Markets':
        return this.dimensionsMM;
      default:
        return [];
    }
  }

  CheckSnapshotNameDuplicate(snapshotName: string) {


    if (this._configService.clientAllSnapshotNames.includes(snapshotName)) {
      this.popUpMessage =
        'SNAPSHOT NAME already exists for this client. Please enter a different name.';
      return false;
    } else {
      return true;
    }
  }
  
  uncheckOnError(item: any, event: any) {
    if(item.name == "Static Time Frame") {
      this.isStaticTimeFrame = false;
      this._configService.isStaticTimeFrame = false;
    }
    else{
      this.isPreviousPeriosOrYear = false;
    }
    event.target.checked = false;
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();
  }
}
